export default {
  /**
   * Find the module the passed level is within
   */
  getModuleFor: state => level => {
    return state.modules.find(module => module.levels.some(l => l.node_id === level.node_id));
  },

  /**
   * Determine if a level should be locked or not based on the internal store's
   * progress state.
   */
  isAvailable: state => (module, level) => {
    if (["quote", "intro"].includes(level.type)) {
      // always enable quotes
      return true;
    }

    if (level.weight <= state.progress.weight + 1) {
      // always enable every previous level + the next one
      return true;
    }

    // get a flat map of all levels' type and weight
    let flatWeight = 0;
    const sortedLevels = state.modules
      .reduce((acc, module) => acc.concat(module.levels), [])
      .map(level => ({
        type: level.type,
        weight: level.weight,
        flatWeight: flatWeight++,
      }))
      .sort((a, b) => (a.flatWeight < b.flatWeight ? -1 : 1))
      .filter(l => !["quote", "intro"].includes(l.type));

    const currentIndex = sortedLevels.findIndex(l => l.weight === state.progress.weight);

    return level.weight <= sortedLevels[currentIndex + 1].weight;
  },

  /**
   * A boolean check if the module/level passed appears earlier in the course
   * than the user's current progress set in the internal store.
   */
  isBefore: state => level => level.weight <= state.progress.weight,

  openLevel: (state, getters) => getters.getLevelByNodeId(state.currentLevelId),

  openModule: state => state.modules.find(m => m.active),

  /**
   * Retrieve a module by its user-facing number.
   */
  getModuleByPosition: state => moduleNum => state.modules[moduleNum - 1],

  getLevelByNodeId: state => id =>
    state.modules.reduce((acc, module) => acc.concat(module.levels), []).find(l => l.node_id === id),

  progressLevel: state => state.progress.level,

  progressModule: state => state.progress.module,
};
